import { render, staticRenderFns } from "./relatorioFinaceiroIOFPaisagem.vue?vue&type=template&id=afd2b548"
import script from "./relatorioFinaceiroIOFPaisagem.vue?vue&type=script&lang=js"
export * from "./relatorioFinaceiroIOFPaisagem.vue?vue&type=script&lang=js"
import style0 from "./relatorioFinaceiroIOFPaisagem.vue?vue&type=style&index=0&id=afd2b548&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports